import React from "react";
import {
  Container,
  Paper,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
  Box,
  Chip,
  Stack,
  Divider,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

const recipientTypes = [
  { value: "founder", label: "Founder" },
  { value: "investor", label: "Investor" },
  { value: "partner", label: "Partner" },
];

const placeholderChips = ["First Name", "Startup Name", "Date"];

const validationSchema = Yup.object({
  to: Yup.string().required("Recipient type is required"),
  mailType: Yup.string().required(),
  subject: Yup.string().required("Subject is required").min(5, "Subject must be at least 5 characters"),
  message: Yup.string().required("Message body is required").min(20, "Message body must be at least 20 characters"),
});

export default function CustomizeEmailTemplate() {
  const formik = useFormik({
    initialValues: {
      to: "",
      mailType: "default",
      subject: "",
      message: "",
    },
    validationSchema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const handleChipClick = (field, value) => {
    formik.setFieldValue(field, formik.values[field] + `{{${value}}} `);
  };

  return (
    <Container maxWidth="sm" sx={{ pt: 4 }}>
      <Paper
        elevation={2}
        sx={{
          p: 4,
          background: "#faf8f5", // Slightly off-white
          borderRadius: 4,
        }}
      >
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Customize Email Template
        </Typography>

        {/* Recipient Type Dropdown */}
        <FormControl fullWidth margin="normal">
          <InputLabel id="to-label">To</InputLabel>
          <Select
            labelId="to-label"
            id="to"
            name="to"
            value={formik.values.to}
            label="To"
            onChange={formik.handleChange}
            sx={{ background: "#f9f6f1" }}
          >
            <MenuItem value="">Select recipient type</MenuItem>
            {recipientTypes.map((r) => (
              <MenuItem key={r.value} value={r.value}>
                {r.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Mail Type Radio Buttons */}
        <Typography fontWeight={700} mt={2} mb={1}>
          Mail Type
        </Typography>
        <RadioGroup
          name="mailType"
          value={formik.values.mailType}
          onChange={formik.handleChange}
          row
        >
          <FormControlLabel
            value="default"
            control={<Radio />}
            label="Send Default Mail"
          />
          <FormControlLabel
            value="custom"
            control={<Radio />}
            label="Send Customized Mail"
          />
        </RadioGroup>
        <Divider sx={{ my: 2 }} />

        {/* Subject Field + Chips */}
        <Typography fontWeight={700} mb={1}>
          Subject
        </Typography>
        <TextField
          id="subject"
          name="subject"
          fullWidth
          variant="outlined"
          placeholder="Enter email subject..."
          value={formik.values.subject}
          onChange={formik.handleChange}
          sx={{ background: "#faf8f5" }}
        />
        <Stack direction="row" spacing={1} mt={1}>
          {placeholderChips.slice(0, 2).map((chip) => (
            <Chip
              key={chip}
              label={chip}
              variant="outlined"
              clickable
              onClick={() => handleChipClick("subject", chip)}
            />
          ))}
        </Stack>
        <Divider sx={{ my: 2 }} />

        {/* Message Body + Chips */}
        <Typography fontWeight={700} mb={1}>
          Message Body
        </Typography>
        <TextField
          id="message"
          name="message"
          fullWidth
          multiline
          minRows={5}
          variant="outlined"
          placeholder="Enter your message..."
          value={formik.values.message}
          onChange={formik.handleChange}
          sx={{ background: "#faf8f5" }}
        />
        <Stack direction="row" spacing={1} mt={1}>
          <Chip
            icon={
              <span
                style={{
                  display: "inline-block",
                  fontWeight: "bold",
                  width: 16,
                  textAlign: "center",
                }}
              >
                &#x25A1;
              </span>
            }
            label=""
            variant="outlined"
          />
          {placeholderChips.map((chip) => (
            <Chip
              key={chip}
              label={chip}
              variant="outlined"
              clickable
              onClick={() => handleChipClick("message", chip)}
            />
          ))}
        </Stack>

        {/* Save Button */}
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Button
            type="submit"
            variant="contained"
            onClick={formik.handleSubmit}
            sx={{
              background: "#1654E6",
              color: "#fff",
              px: 5,
              fontWeight: 600,
              borderRadius: 2,
              boxShadow: 0,
            }}
            size="large"
          >
            Save
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
